import styled from 'styled-components';
//
import { IThemeProps } from 'theme';

export default styled.div(props => {
  const { theme }: IThemeProps = props;
  const { colors, fonts } = theme.primary;
  const { darkPanelBackground, yellow, lightBackgroundBase } = colors;

  return {
    alignItems: 'center',
    height: 56,
    display: 'flex',
    'flex-direction': 'row',
    background: darkPanelBackground,
    h1: { ...fonts.h1, fontSize: 22, color: `${lightBackgroundBase} !important` },
    borderBottom: `3px solid ${yellow}`,
    boxShadow:
      '0px 1px 3px rgba(29, 29, 37, 0.2), 0px 2px 2px rgba(29, 29, 37, 0.12), 0px 0px 2px rgba(29, 29, 37, 0.14)',
    position: 'fixed',
    width: '100vw',
    zIndex: 5,

    '.container': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  };
});
